<template>
  <div>
    <a-drawer
      width="95%"
      max-width="1700px"
      :visible="showCreateForm"
      :body-style="{ paddingBottom: '15px', paddingTop: '15px'}"
      class="create-project-page"
      @close="close"
      :maskClosable="false"
    >
      <a-form-model ref="form" :model="model" :rules="rules">
        <a-spin :spinning="loading" tip="Loading..." size="large" />

        <div class="steps-container">
          <div class="step">
        <!-- 1. 广告主选择 -->
        <a-form-model-item label="广告主" prop="ids">
          <adv-select v-model="model.ids" :max-tag-count="3" :type="media" @blur="changeAdvs" />
        </a-form-model-item>

        <!-- 绑定优化师（任一广告主未绑定时显示，且必须选择提交） -->
        <a-form-model-item label="绑定优化师" prop="worker_id" v-if="showBindWorker" required>
          <a-select
            show-search
            placeholder="请选择优化师"
            v-model="model.worker_id"
            option-filter-prop="children"
          >
            <a-select-option :value="worker.id" v-for="worker in workers" :key="worker.id">
              {{ worker.name }}
            </a-select-option>
          </a-select>
          <div style="margin-top: 4px; color: #999; font-size: 12px;">
            存在未绑定优化师的广告主，需选择优化师后提交；已绑定优化师的广告主不受影响，头像由系统自动上传默认头像
          </div>
        </a-form-model-item>

        <!-- 2. 营销产品 - 商品库选择 -->
        <template v-if="model.need_product != 2">
          <a-form-model-item label="商品库模式" prop="product_model">
            <a-radio-group v-model="model.product_model" @change="changeProductModel">
              <a-radio-button :value="1">统一设置</a-radio-button>
              <a-radio-button :value="2">分别设置</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <!-- 统一设置 -->
          <template v-if="model.product_model === 1">
            <a-form-model-item label="关联商品库" prop="related_product.product_platform_id">
              <a-row>
                <a-col :span="18">
                  <a-select
                    show-search
                    allow-clear
                    placeholder="请选择"
                    v-model="model.related_product.product_platform_id"
                    option-filter-prop="children"
                    :loading="loading"
                    @change="changeLibrary"
                  >
                    <a-select-option :value="platform.id" v-for="platform in products[model.ids[0]]" :key="platform.id">
                      {{ platform.name }}（ID:{{ platform.id }}）
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-button @click="refreshProducts(model.ids[0], model.related_product.product_platform_id)" style="margin-left:20px">
                    刷新商品库
                  </a-button>
                </a-col>
              </a-row>
            </a-form-model-item>

            <a-form-model-item label="关联产品" prop="related_product.product_id" :loading="loading">
              <a-row>
                <a-col :span="18">
                  <a-select show-search allow-clear placeholder="请选择" v-model="model.related_product.product_id" option-filter-prop="children" @change="changeProductDetail">
                    <a-select-option :value="detail.id" v-for="detail in productDetails[model.related_product.product_platform_id]" :key="detail.id" :playlet_id="detail.playlet_id">
                      {{ detail.name }}（商品ID:{{ detail.id }}，专辑ID:{{ detail.playlet_id }}）
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col :span="6">
                  <a-button @click="refreshProductDetails(model.ids[0], model.related_product.product_platform_id)" style="margin-left:20px" :disabled="!model.related_product.product_platform_id">
                    刷新产品
                  </a-button>
                </a-col>
              </a-row>
            </a-form-model-item>
          </template>

          <!-- 分别设置 -->
          <template v-else>
            <a-form-model-item label="" help='' style="border: 1px solid #87e8de;;padding:20px">
              <div style="margin-bottom: 10px; text-align: right;">
                <a-button type="primary" @click="setBatchProduct">一键设置商品库</a-button>
                <div style="margin-top: 5px; color: orange; font-size: 12px; text-align: right;">
                  <div>关联商品库：会根据账户主体配置的商品库ID自动填充，找不到则不填充；</div>
                  <div>关联产品：会根据账户主体对应推广链接中的剧名去自动填充，找不到则不填充。</div>
                </div>
              </div>
              <a-tabs :default-active-key="0" @change="clickPane" size="small" tabPosition="left" :style="{ height: '300px' }">
                <a-tab-pane v-for="(advertiser,index) in advertisers" :key="index" :tab="renderTab(advertiser, 'product')">
                  <a-form-model-item label="巨量广告主ID">
                    <a-input v-model="advertisers[index].advertiser_id" disabled />
                  </a-form-model-item>

                  <a-form-model-item label="关联商品库">
                    <a-row>
                      <a-col :span="18">
                        <a-select
                          show-search
                          allow-clear
                          placeholder="请选择"
                          v-model="advertisers[index].product_platform_id"
                          option-filter-prop="children"
                          :loading="loading"
                          @change="changeLibrary"
                        >
                          <a-select-option :value="platform.id" v-for="platform in products[advertiser.id]" :key="platform.id" :adv_id="advertiser.id">
                            {{ platform.name }}（ID:{{ platform.id }}）
                          </a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="6">
                        <a-button @click="refreshProducts(advertiser.id, advertiser.product_platform_id)" style="margin-left:20px">
                          刷新商品库
                        </a-button>
                      </a-col>
                    </a-row>
                  </a-form-model-item>

                  <a-form-model-item label="关联产品" :loading="loading">
                    <a-row>
                      <a-col :span="18">
                        <a-select show-search allow-clear placeholder="请选择" v-model="advertisers[index].product_id" option-filter-prop="children" @change="changeAdvertiserProductDetail">
                          <a-select-option :value="detail.id" v-for="detail in productDetails[advertiser.product_platform_id]" :key="detail.id" :outer_id="detail.outer_id" :adv_id="advertiser.id" :id="detail.id" :playlet_id="detail.playlet_id">
                            {{ detail.name }}（商品ID:{{ detail.id }}，专辑ID:{{ detail.playlet_id }}）
                          </a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="6">
                        <a-button @click="refreshProductDetails(advertiser.id, advertiser.product_platform_id)" style="margin-left:20px" :disabled="!advertiser.product_platform_id">
                          刷新产品
                        </a-button>
                      </a-col>
                    </a-row>
                  </a-form-model-item>
                </a-tab-pane>
              </a-tabs>
            </a-form-model-item>
          </template>
        </template>

        <!-- 3. 投放载体 - 抖音号（按商品专辑过滤，分页加载，可抖音ID搜索） -->
        <a-form-model-item label="抖音号" prop="ad.native_setting.aweme_id" help="根据所选商品的专辑ID过滤可投放抖音号；一个商品有且只能在一个抖音号进行投放">
          <uni-aweme-select
            :value="model.ad.native_setting.aweme_id"
            :advertiser-id="model.ids[0]"
            :playlet-id="model.related_product.playlet_id"
            @change="handleUniAwemeChange"
          />
        </a-form-model-item>

        <!-- 4. 设置主页可见性 -->
        <a-form-model-item label="设置主页可见性" prop="ad.video_hp_visibility">
          <a-radio-group v-model="model.ad.video_hp_visibility">
            <a-radio-button value="ALWAYS_VISIBLE">主页始终可见</a-radio-button>
            <a-radio-button value="HIDE_VIDEO_ON_HP">仅单次展示可见</a-radio-button>
          </a-radio-group>
        </a-form-model-item>

        <!-- 5. 投放设置区 -->
        <a-divider orientation="left">投放设置</a-divider>

        <!-- 5.1 日预算 -->
        <a-form-model-item label="日预算" prop="budget">
          <a-input-number v-model="model.budget" :min="300" :max="9999999" :precision="2" style="width: 100%" addon-after="元" />
        </a-form-model-item>

        <!-- 5.2 全域ROI系数 -->
        <a-form-model-item label="全域ROI系数" prop="roi_goal">
          <a-input-number v-model="model.roi_goal" :min="0.01" :max="5" :precision="4" :step="0.01" style="width: 100%" />
        </a-form-model-item>

        <!-- 5.3 投放变现模式 -->
        <a-form-model-item label="投放变现模式" prop="monetization_mode">
          <a-radio-group v-model="model.monetization_mode" @change="onMonetizationModeChange">
            <a-radio value="IAP">用户付费(IAP)</a-radio>
            <a-radio value="IAA_AND_IAP">混合投放(IAA+IAP)</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <!-- 5.4 定向调控 -->
        <a-form-model-item label="定向调控">
          <a-radio-group v-model="model.audience_targeting">
            <a-radio value="unlimited">不限</a-radio>
            <a-radio value="custom">自定义</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <template v-if="model.audience_targeting === 'custom'">
          <a-form-model-item label="地域" prop="audience.district">
            <a-radio-group v-model="model.audience.district">
              <a-radio-button value="NONE">不限</a-radio-button>
              <a-radio-button value="REGION">除北上广深</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="性别" prop="audience.gender">
            <a-radio-group v-model="model.audience.gender">
              <a-radio-button value="NONE">不限</a-radio-button>
              <a-radio-button value="GENDER_MALE">男</a-radio-button>
              <a-radio-button value="GENDER_FEMALE">女</a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="年龄" prop="audience.age">
            <a-checkbox-group v-model="model.audience.age" @change="changeAge">
              <a-checkbox name="age" :value="age.id" v-for="age in ages" :key="age.id">
                {{ age.name }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>

          <a-form-model-item label="平台" prop="audience.platform">
            <a-checkbox-group v-model="model.audience.platform" @change="changePlatform">
              <a-checkbox name="platform" :value="platform.id" v-for="platform in platforms" :key="platform.id">
                {{ platform.name }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
        </template>

        <!-- 5.5 投放时间 -->
        <a-form-model-item label="投放时间" prop="delivery_setting.schedule_type">
          <a-radio-group v-model="model.delivery_setting.schedule_type">
            <a-radio-button value="SCHEDULE_FROM_NOW">从今天起长期投放</a-radio-button>
            <a-radio-button value="SCHEDULE_START_END">设置开始和结束日期</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="" prop="delivery_setting.schedule_date" v-if="model.delivery_setting.schedule_type=='SCHEDULE_START_END'">
          <a-range-picker v-model="model.delivery_setting.schedule_date" valueFormat="YYYY-MM-DD" :disabled-date="disabledDate"/>
        </a-form-model-item>

        <!-- 5.6 投放时段 -->
        <a-form-model-item label="投放时段" prop="delivery_setting.schedule_time_type">
          <a-radio-group v-model="model.delivery_setting.schedule_time_type">
            <a-radio-button :value="1">不限</a-radio-button>
            <a-radio-button :value="2">指定时间段</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="" prop="delivery_setting.schedule_time" v-if="model.delivery_setting.schedule_time_type==2">
          <byted-schedule v-model="model.delivery_setting.schedule_time" show-checkbox>
            <span slot="header"></span>
          </byted-schedule>
        </a-form-model-item>

        <!-- 6. 素材设置区 -->
        <a-divider orientation="left">素材设置</a-divider>

        <!-- 6.1 素材补充方式 -->
        <a-form-model-item label="素材补充方式">
          <a-checkbox-group v-model="model.material_supplement">
            <a-checkbox value="self" disabled>自选素材</a-checkbox>
            <a-checkbox value="aigc">AIGC动态素材</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>

        <!-- 6.2 添加素材 - 三Tab模式 -->
        <a-tabs :default-active-key="material_type" @change="materialTypeChange">
          <a-tab-pane :key="1" tab="账户素材">
            <template v-if="material_type==1">
              <a-form-model-item prop="ad.video_ids" label="广告素材" help="所选素材将随机平均分配至广告列表">
                <div style="display: flex; align-items: center;">
                  <a-select placeholder="选择广告主" v-model="currentAdvId" @change="changeAdvertiser" show-search option-filter-prop="children" style="width: 220px; margin-right: 10px;">
                    <a-select-option :value="item.id" v-for="item in advertisers" :key="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                  <video-select
                    v-model="model.ad.video_ids"
                    :max-num="200"
                    :advertiser-id="currentAdvId"
                    :media="media"
                    v-if="currentAdvId > 0"
                  />
                </div>
              </a-form-model-item>
            </template>
          </a-tab-pane>
          <a-tab-pane :key="2" tab="本地素材库" force-render>
            <div class="local-material-scroll">
              <template v-if="material_type==2">
                <a-form-model-item prop="ad.video_ids_local" label="广告素材" help="所选素材将随机平均分配至广告列表">
                  <material-select
                    v-model="model.ad.video_ids_local"
                    :filters="{ type: 3, num: 200, isBatchSelect:true, need_sync_juliang_or_organize:true, from_local_select: true}"
                    :returnData="model.ad.video_ids_local"
                    @change="changeVideo"
                    :simpleMode=true
                  />
                </a-form-model-item>
              </template>
            </div>
          </a-tab-pane>
          <a-tab-pane :key="3" tab="素材排行">
            <template v-if="material_type==3">
              <a-form-model-item prop="ad.video_ids_rank" label="广告素材" help="所选素材将随机平均分配至广告列表">
                <video-rank-select
                  v-model="model.ad.video_ids_rank"
                  :max-num="200"
                  :media="media"
                  :filter=true
                />
              </a-form-model-item>
            </template>
          </a-tab-pane>
          <a-tab-pane :key="4" tab="组织素材" v-if="media === 'juliang'">
            <template v-if="material_type==4">
              <a-form-model-item prop="ad.video_ids_org" label="广告素材" help="所选素材将随机平均分配至广告列表">
                <div style="display: flex; align-items: center;">
                  <a-select placeholder="选择广告主" v-model="currentAdvId" @change="changeAdvertiser" show-search option-filter-prop="children" style="width: 220px; margin-right: 10px;">
                    <a-select-option :value="item.id" v-for="item in advertisers" :key="item.id">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                  <org-video-select
                    v-model="model.ad.video_ids_org"
                    :max-num="200"
                    :advertiser-id="currentAdvId"
                    :media="media"
                    v-if="currentAdvId > 0"
                  />
                </div>
              </a-form-model-item>
            </template>
          </a-tab-pane>
        </a-tabs>

        <!-- 7. 短剧专辑链接区 -->
        <a-divider orientation="left">短剧专辑链接</a-divider>

        <!-- 短剧类型 + 同步按钮 -->
        <a-form-model-item label="短剧类型" prop="playlet_type">
          <a-radio-group v-model="model.playlet_type">
            <a-radio :value="1">真人剧</a-radio>
            <a-radio :value="2">漫剧</a-radio>
          </a-radio-group>
          <div style="margin-top: 8px;">
            <a-button type="primary" size="small" :loading="syncLocalLoading" @click="syncLocalLinks" :disabled="!model.related_product.playlet_id || !model.playlet_type">
              一键同步本地常读分销链接
            </a-button>
            <a-button type="primary" size="small" style="margin-left: 8px;" :loading="syncChangduLoading" @click="syncChangduLinks" :disabled="!model.related_product.playlet_id || !model.playlet_type">
              一键同步常读分销链接
            </a-button>
            <span v-if="!model.related_product.playlet_id" style="margin-left: 8px; color: #999; font-size: 12px;">请先选择关联产品</span>
          </div>
        </a-form-model-item>

        <!-- IAA链接（混合模式时显示，仅1条） -->
        <a-form-model-item label="IAA链接" v-if="model.monetization_mode === 'IAA_AND_IAP'" prop="iaa_url_list">
          <div v-for="(_, index) in model.iaa_url_list" :key="'iaa-' + index" style="margin-bottom: 8px">
            <div v-if="iaaLinkDescs[index]" style="font-size: 12px; color: #1890ff; margin-bottom: 2px;">{{ iaaLinkDescs[index] }}</div>
            <a-input v-model="model.iaa_url_list[index]" placeholder="请输入IAA短剧专辑链接（仅1条）" style="width: calc(100% - 40px)" @blur="onLinkBlur('iaa', index)" />
            <div v-if="getLinkValidationError(model.iaa_url_list[index])" style="color: #f5222d; font-size: 12px; margin-top: 2px;">{{ getLinkValidationError(model.iaa_url_list[index]) }}</div>
          </div>
        </a-form-model-item>

        <!-- IAP链接（1-10条，可动态增删） -->
        <a-form-model-item label="IAP链接" prop="iap_url_list">
          <div v-for="(_, index) in model.iap_url_list" :key="'iap-' + index" style="margin-bottom: 8px">
            <div v-if="iapLinkDescs[index]" style="font-size: 12px; color: #1890ff; margin-bottom: 2px;">{{ iapLinkDescs[index] }}</div>
            <a-input v-model="model.iap_url_list[index]" placeholder="请输入IAP短剧专辑链接" style="width: calc(100% - 40px)" @blur="onLinkBlur('iap', index)" />
            <a-button v-if="model.iap_url_list.length > 1" type="danger" icon="delete" size="small" @click="removeIapUrl(index)" style="margin-left: 8px" />
            <div v-if="getLinkValidationError(model.iap_url_list[index])" style="color: #f5222d; font-size: 12px; margin-top: 2px;">{{ getLinkValidationError(model.iap_url_list[index]) }}</div>
          </div>
          <a-button v-if="model.iap_url_list.length < 10" type="dashed" icon="plus" size="small" @click="addIapUrl">添加IAP链接</a-button>
        </a-form-model-item>

        <!-- 8. 文案设置区 -->
        <a-divider orientation="left">文案设置</a-divider>

        <!-- 文案素材标题 -->
        <a-form-model-item label="文案素材标题" prop="ad.promotion_materials.title_material_list">
          <code-input ref="title_group" class="title-group" v-model="model.ad.promotion_materials.title_material_list" />
          <div>
            <span>多个标题可按回车分隔，也可以批量导入 </span>
            <a-button type="primary" @click="showModal">
              本地文案库
            </a-button>
          </div>
        </a-form-model-item>

        <!-- 产品名称 -->
        <a-form-model-item label="产品名称" prop="ad.promotion_materials.product_info.titles">
          <a-auto-complete :data-source="product_titles" v-model="model.ad.promotion_materials.product_info.titles" />
        </a-form-model-item>

        <!-- 产品主图 -->
        <a-form-model-item label="产品主图" prop="ad.promotion_materials.product_info.image">
          <material-select
            v-model="model.ad.promotion_materials.product_info.image"
            :filters="{ type: 2, num: 1, width: 108, height: 108, size: 5 }"
            @delete="deleteImage"
          />
        </a-form-model-item>

        <!-- 产品卖点 -->
        <a-form-model-item label="产品卖点" prop="ad.promotion_materials.product_info.selling_points" help="">
          <a-select
            mode="tags"
            show-search
            allow-clear
            placeholder="请选择"
            v-model="model.ad.promotion_materials.product_info.selling_points"
            option-filter-prop="children"
          >
            <a-select-option :value="item" v-for="item in sellingPoints" :key="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 行动号召 -->
        <a-form-model-item label="行动号召" prop="ad.promotion_materials.call_to_action_buttons">
          <a-select
            mode="tags"
            show-search
            allow-clear
            placeholder="请选择"
            v-model="model.ad.promotion_materials.call_to_action_buttons"
            option-filter-prop="children"
          >
            <a-select-option :value="button" v-for="button in buttons" :key="button">
              {{ button }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <!-- 自定义抖音号名称（非必填，填写则统一使用，未填写则默认抖音号名称） -->
        <a-form-model-item label="自定义抖音号名称" prop="ad.source" help="非必填，填写后所有项目统一使用该名称；未填写则使用抖音号名称">
          <a-auto-complete :data-source="sources" v-model="model.ad.source" />
        </a-form-model-item>

        <!-- 项目名称 -->
        <a-form-model-item prop="name" label="项目名称">
          <a-input v-model="model.name" />
        </a-form-model-item>

        <!-- 底部按钮 -->
        <div class="steps-action">
          <div class="button-group">
            <a-button :style="{ marginRight: '8px' }" @click="close">取消</a-button>
            <a-button type="primary" :loading="loading" @click="submit">提交</a-button>
          </div>
        </div>
          </div>
        </div>
      </a-form-model>
    </a-drawer>

    <!-- 本地文案库弹窗 -->
    <a-modal v-model="visible" title="本地文案库" @ok="handleOk" :width="1200" :body-style="{ maxHeight: 'none' }">
      <div class="title-group-page">
        <title-group :titleGroups="titleGroups" @select="setTitleGroup" />
      </div>
    </a-modal>
  </div>
</template>
<style lang="less" scoped>
@import 'Create';
</style>

<script>
import Create from './Create'
import UniAwemeSelect from './UniAwemeSelect.vue'
export default {
    ...Create,
    components: {
        ...(Create.components || {}),
        UniAwemeSelect,
    },
}
</script>
